<script>
  export let username = "";
  export let fratName = "";
  export let className = "";

  const BASE = "https://fratdoor-crest-pics.s3.us-east-2.amazonaws.com";
  const EXTS = ["png", "jpg", "jpeg", "webp"];

  function norm(s) {
    return (s || "").trim();
  }

  function sanitizeName(s) {
    // turn "Alpha Phi Delta" -> "Alpha_Phi_Delta"
    return norm(s).replace(/[^A-Za-z0-9]+/g, "_");
  }

  // Build list of candidate filenames (no extension)
  $: candidates = (() => {
    const bases = new Set();

    const u = norm(username);
    const f = norm(fratName);
    const fs = sanitizeName(f);

    if (u) {
      bases.add(u);
      bases.add(u.toUpperCase());
      bases.add(u.toLowerCase());
      if (!u.toUpperCase().endsWith("_ADMIN")) {
        bases.add(u.toUpperCase() + "_ADMIN");
      }
    }

    if (fs) {
      bases.add(fs);
      bases.add(fs.toUpperCase());
      bases.add(fs.toLowerCase());
      if (!fs.toUpperCase().endsWith("_ADMIN")) {
        bases.add(fs.toUpperCase() + "_ADMIN");
      }
    }

    const urls = [];
    for (const b of bases) {
      for (const ext of EXTS) {
        urls.push(`${BASE}/${b}.${ext}`);
      }
    }
    return urls;
  })();

  let idx = 0;
  $: src = candidates[idx] || "";

  function handleError() {
    if (idx < candidates.length - 1) {
      idx += 1;
      src = candidates[idx];
    } else {
      src = "";
    }
  }
</script>

{#if src}
  <img
    src={src}
    alt="Chapter crest"
    class={className}
    on:error={handleError}
  />
{/if}
